export default __webpack_public_path__ + "static/media/bci-4-hover.e166d548.svg";